/**
 *
 */
export class GenericTextIds {

    /* PROJECT: GENERIC FLASH ********************************************/

    //alert
    public static ALERT_BUG: string = "generic_alert_bug";
    public static ALERT_CONNECTION_FAILED_COPY: string = "generic_alert_connection_failed_copy";
    public static ALERT_CONNECTION_FAILED_TITLE: string = "generic_alert_connection_failed_title";
    public static ALERT_CONNECTION_LOST_COPY: string = "generic_alert_connection_lost_copy";
    public static ALERT_CONNECTION_LOST_DESCRIPTION: string = "generic_alert_connection_lost_description";
    public static ALERT_CONNECTION_LOST_PROMO: string = "generic_alert_connection_lost_promo";
    public static ALERT_CONNECTION_LOST_THANKS: string = "generic_alert_connection_lost_thanks";
    public static ALERT_CONNECTION_LOST_TITLE: string = "generic_alert_connection_lost_title";
    public static ALERT_ERROR: string = "generic_alert_error";
    public static ALERT_INFORMATION: string = "generic_alert_information";
    public static ALERT_LOGGEDOUT_COPY: string = "generic_alert_loggedout_copy";
    public static ALERT_LOGGEDOUT_TITLE: string = "generic_alert_loggedout_title";
    public static ALERT_WARNING: string = "generic_alert_warning";
    public static ALERT_WATCHOUT: string = "generic_alert_watchout";
    public static ALERT_WIN7CHROMEBUG: string = "generic_alert_win7chromebug";
    public static ALERT_INVALID_EMAIL_PROVIDER: string = "generic_invalid_email_provider";
    public static ALERT_JS_FIRSTSESSIONTRACKING_LOADING: string = "generic_js_alert_firstsessiontracking_loading";
    public static ALERT_JS_FIRSTSESSIONTRACKING_REGISTERED: string = "generic_js_alert_firstsessiontracking_registered";
    public static ALERT_JS_FIRSTSESSIONTRACKING_UNREGISTERED: string = "generic_js_alert_firstsessiontracking_unregistered";
    public static ALERT_REGISTER_ERROR_INVALIDEMAIL: string = "generic_register_error_invalidemail";
    public static ALERT_REPORT_MUTED_CHATTRY: string = "generic_report_muted_chattry";

    // buttons
    public static BUTTON_ACCEPT: string = "generic_btn_accept";
    public static BUTTON_CANCEL: string = "generic_btn_cancel";
    public static BUTTON_CLOSE: string = "generic_btn_close";
    public static BUTTON_CONTINUE: string = "generic_btn_continue";
    public static BUTTON_END: string = "generic_btn_end";
    public static BUTTON_ENDNOW: string = "generic_btn_endnow";
    public static BUTTON_GOBACK: string = "generic_btn_goback";
    public static BUTTON_NO: string = "generic_btn_no";
    public static BUTTON_NOSHARE: string = "generic_btn_noshare";
    public static BUTTON_NOTACCEPT: string = "generic_btn_notaccept";
    public static BUTTON_OKAY: string = "generic_btn_okay";
    public static BUTTON_RECONNECT: string = "generic_btn_reconnect";
    public static BUTTON_REFRESH: string = "generic_btn_refresh";
    public static BUTTON_REPORT: string = "generic_btn_report";
    public static BUTTON_SEARCH: string = "generic_btn_search";
    public static BUTTON_SHARE: string = "generic_btn_share";
    public static BUTTON_SKIP: string = "generic_btn_skip";
    public static BUTTON_START: string = "generic_btn_start";
    public static BUTTON_TOPAYMENT: string = "generic_btn_topayment";
    public static BUTTON_YES: string = "generic_btn_yes";

    // chat
    public static CHAT_NOCHATMESSAGE: string = "generic_chat_noChatMessage";
    public static CHAT_WRITEABLE: string = "generic_chat_writeable";

    // cm teasers
    public static CM_TEASER_COPY_01: string = "cm_teaser1_copy";
    public static CM_TEASER_COPY_02: string = "cm_teaser2_copy";
    public static CM_TEASER_COPY_03: string = "cm_teaser3_copy";
    public static CM_TEASER_COPY_04: string = "cm_teaser4_copy";
    public static CM_TEASER_COPY_05: string = "cm_teaser5_copy";
    public static CM_TEASER_COPY_06: string = "cm_teaser6_copy";
    public static CM_TEASER_COPY_07: string = "cm_teaser7_copy";
    public static CM_TEASER_COPY_08: string = "cm_teaser8_copy";
    public static CM_TEASEREVENT_TITLE: string = "cm_teaserevent_title";
    public static CM_TEASERINFO_TITLE: string = "cm_teaserinfo_title";
    public static CM_TEASERWARNING_TITLE: string = "cm_teaserwarning_title";

    // common
    public static COMMON_ADMIN: string = "generic_admin";
    public static COMMON_ANIMATION: string = "generic_animation";
    public static COMMON_BETA: string = "generic_beta";
    public static COMMON_BUGREPORT: string = "generic_bugreport";
    public static COMMON_CHANGEPASS: string = "generic_changePass";
    public static COMMON_COMMA: string = "generic_comma";
    public static COMMON_COMINGSOON: string = "generic_conningsoon";
    public static COMMON_DATE: string = "generic_date";
    public static COMMON_DAY: string = "generic_day";
    public static COMMON_DAYFORMAT: string = "generic_dayformat";
    public static COMMON_DAYFORMAT_SHORT: string = "generic_dayformat_short";
    public static COMMON_DAYS: string = "generic_days";
    public static COMMON_DAY_SHORT: string = "generic_day_short";
    public static COMMON_DECIMALSEPARATOR: string = "generic_decimalseparator";
    public static COMMON_EMAIL: string = "generic_email";
    public static COMMON_EMBEDEDSIGNS: string = "generic_embededSigns";
    public static COMMON_FAQ: string = "generic_faq";
    public static COMMON_FORUM: string = "generic_forum";
    public static COMMON_FRIEND: string = "generic_friend";
    public static COMMON_FRIENDS: string = "generic_friends";
    public static COMMON_GENERAL: string = "generic_general";
    public static COMMON_GGS: string = "generic_ggs";
    public static COMMON_GROUP: string = "generic_group";
    public static COMMON_GUEST: string = "generic_guest";
    public static COMMON_HELP: string = "generic_help";
    public static COMMON_HIGH: string = "generic_high";
    public static COMMON_HOUR: string = "generic_hour";
    public static COMMON_HOURS: string = "generic_hours";
    public static COMMON_HOUR_SHORT: string = "generic_hour_short";
    public static COMMON_LIMITED: string = "generic_limited";
    public static COMMON_LOGOUT: string = "generic_logout";
    public static COMMON_MEDIUM: string = "generic_medium";
    public static COMMON_LOW: string = "generic_low";
    public static COMMON_MINUTE: string = "generic_minute";
    public static COMMON_MINUTES: string = "generic_minutes";
    public static COMMON_MINUTE_SHORT: string = "generic_minute_short";
    public static COMMON_MODERATOR: string = "generic_moderator";
    public static COMMON_MONTH: string = "generic_month";
    public static COMMON_MONTHS: string = "generic_months";
    public static COMMON_MONTH_SHORT: string = "generic_month_short";
    public static COMMON_MUSIC: string = "generic_music";
    public static COMMON_NAME: string = "generic_name";
    public static COMMON_NEWS: string = "generic_news";
    public static COMMON_OPTIONS: string = "generic_options";
    public static COMMON_QUALITY: string = "generic_quality";
    public static COMMON_REGISTER: string = "generic_register";
    public static COMMON_SECOND: string = "generic_second";
    public static COMMON_SECONDS: string = "generic_seconds";
    public static COMMON_SECOND_SHORT: string = "generic_second_short";
    public static COMMON_SOUND: string = "generic_sound";
    public static COMMON_SUPPORT: string = "generic_support";
    public static COMMON_TODAY: string = "generic_today";
    public static COMMON_TOMORROW: string = "generic_tomorrow";
    public static COMMON_TUTORIAL: string = "generic_tutorial";
    public static COMMON_USERNAME: string = "generic_username";
    public static COMMON_VALIDTO_TIMER: string = "generic_validTo_timer";
    public static COMMON_XP: string = "generic_xp";
    public static COMMON_YESTERDAY: string = "generic_yesterday";

    // countries
    public static COUNTRIES_AU: string = "generic_country_AU";
    public static COUNTRIES_BG: string = "generic_country_BG";
    public static COUNTRIES_BR: string = "generic_country_BR";
    public static COUNTRIES_CN: string = "generic_country_CN";
    public static COUNTRIES_CZ: string = "generic_country_CZ";
    public static COUNTRIES_DE: string = "generic_country_DE";
    public static COUNTRIES_DK: string = "generic_country_DK";
    public static COUNTRIES_ES: string = "generic_country_ES";
    public static COUNTRIES_FI: string = "generic_country_FI";
    public static COUNTRIES_FR: string = "generic_country_FR";
    public static COUNTRIES_GB: string = "generic_country_GB";
    public static COUNTRIES_GR: string = "generic_country_GR";
    public static COUNTRIES_HU: string = "generic_country_HU";
    public static COUNTRIES_INTERNATIONAL: string = "generic_country_international";
    public static COUNTRIES_IT: string = "generic_country_IT";
    public static COUNTRIES_JP: string = "generic_country_JP";
    public static COUNTRIES_KP: string = "generic_country_KP";
    public static COUNTRIES_KR: string = "generic_country_KR";
    public static COUNTRIES_LT: string = "generic_country_LT";
    public static COUNTRIES_NL: string = "generic_country_NL";
    public static COUNTRIES_NO: string = "generic_country_NO";
    public static COUNTRIES_PL: string = "generic_country_PL";
    public static COUNTRIES_PT: string = "generic_country_PT";
    public static COUNTRIES_RO: string = "generic_country_RO";
    public static COUNTRIES_RU: string = "generic_country_RU";
    public static COUNTRIES_SE: string = "generic_country_SE";
    public static COUNTRIES_SK: string = "generic_country_SK";
    public static COUNTRIES_TR: string = "generic_country_TR";
    public static COUNTRIES_US: string = "generic_country_US";

    // error
    public static ERROR_VERSIONCHECK: string = "generic_versioncheck_error";
    public static ERROR_VERSIONCHECK_ERRCODE_1: string = "generic_versioncheck_errorcode_1";
    public static ERROR_FULLSCREEN_ERROR_COPY: string = "generic_fullscreen_error_copy";
    public static ERRORCODE: string = "errorCode_";
    public static ERROR_BADWORD: string = "error_badword";
    public static ERROR_MAIL_EMPTY: string = "error_mail_empty";

    public static ERROR_NAME_EMPTY: string = "error_name_empty";
    public static ERROR_NAME_INVALID: string = "error_name_invalid";
    public static ERROR_NAME_TOO_SHORT: string = "error_name_too_short";

    // friends
    public static FRIENDS_ADD_COPY: string = "generic_friends_add_copy";
    public static FRIENDS_ADD_TITLE: string = "generic_friends_add_title";
    public static FRIENDS_BUDDY_BTN_MOREFRIENDS: string = "generic_friends_buddy_btn_morefriends";
    public static FRIENDS_DENIED_COPY: string = "generic_friends_denied_copy";
    public static FRIENDS_DENIED_TITLE: string = "generic_friends_denied_title";
    public static FRIENDS_INVITE_BADWORD_COPY: string = "generic_friends_invite_badword_copy";
    public static FRIENDS_INVITE_BADWORD_TITLE: string = "generic_friends_invite_badword_title";
    public static FRIENDS_INVITE_ERROR_COPY: string = "generic_friends_invite_error_copy";
    public static FRIENDS_INVITE_ERROR_TITLE: string = "generic_friends_invite_error_title";

    // languages
    public static LANGUAGE_BG: string = "generic_language_bg";
    public static LANGUAGE_CS: string = "generic_language_cs";
    public static LANGUAGE_CZ: string = "generic_language_cz";
    public static LANGUAGE_DA: string = "generic_language_da";
    public static LANGUAGE_DE: string = "generic_language_de";
    public static LANGUAGE_EL: string = "generic_language_el";
    public static LANGUAGE_EN: string = "generic_language_en";
    public static LANGUAGE_ES: string = "generic_language_es";
    public static LANGUAGE_FI: string = "generic_language_fi";
    public static LANGUAGE_FR: string = "generic_language_fr";
    public static LANGUAGE_HU: string = "generic_language_hu";
    public static LANGUAGE_ID: string = "generic_language_id";
    public static LANGUAGE_IT: string = "generic_language_it";
    public static LANGUAGE_JA: string = "generic_language_ja";
    public static LANGUAGE_KO: string = "generic_language_ko";
    public static LANGUAGE_NL: string = "generic_language_nl";
    public static LANGUAGE_NO: string = "generic_language_no";
    public static LANGUAGE_PL: string = "generic_language_pl";
    public static LANGUAGE_PT: string = "generic_language_pt";
    public static LANGUAGE_PT_BR: string = "generic_language_pt_BR";
    public static LANGUAGE_RO: string = "generic_language_ro";
    public static LANGUAGE_RU: string = "generic_language_ru";
    public static LANGUAGE_SK: string = "generic_language_sk";
    public static LANGUAGE_SKN: string = "generic_language_skn";
    public static LANGUAGE_SV: string = "generic_language_sv";
    public static LANGUAGE_TR: string = "generic_language_tr";
    public static LANGUAGE_ZH_CN: string = "generic_language_zh_CN";
    public static LANGUAGE_ZH_TW: string = "generic_language_zh_TW";

    // login messages
    public static LOGIN_BANNED: string = "generic_login_banned";
    public static LOGIN_BANNED_2: string = "generic_login_banned_2";
    public static LOGIN_BANNED_3: string = "generic_login_banned_3";
    public static LOGIN_BANNED_PERMANENT: string = "generic_login_banned_permanent";
    public static LOGIN_FACEBOOK: string = "generic_login_facebook";
    public static LOGIN_LOGIN: string = "generic_login_login";
    public static LOGIN_LOGINNAME: string = "generic_login_loginname";
    public static LOGIN_LOSTPASSWORD: string = "generic_login_lostpassword";
    public static LOGIN_LOSTPASSWORD_COPY: string = "generic_login_lostpassword_copy";
    public static LOGIN_LOSTPASSWORD_TITLE: string = "generic_login_lostpassword_title";
    public static LOGIN_NEWPLAYER: string = "generic_login_newplayer";
    public static LOGIN_PASSWORD: string = "generic_login_password";
    public static LOGIN_PLAY: string = "generic_login_play";
    public static LOGIN_PLAYNOW: string = "generic_login_playnow";
    public static LOGIN_REGISTER: string = "generic_login_register";
    public static LOGIN_REMEMBERPASSWORD: string = "generic_login_rememberpassword";
    public static LOGIN_WRONGLOGIN: string = "generic_login_wronglogin";

    public static GENERIC_REGISTER_BUTTON_TEXT_3: string = "generic_register_button_text_3";
    public static GENERIC_REGISTER_BUTTON_TEXT_2: string = "generic_register_button_text_2";
    public static GENERIC_REGISTER_AGB_INFO_1: string = "generic_register_agb_info_1";

    // logout messages
    public static LOGOUT_GUEST_COPY: string = "generic_logout_guest_copy";
    public static LOGOUT_GUEST_TITLE: string = "generic_logout_guest_title";

    // server notifications
    public static SERVER_SHUTDOWNPREMONITION_BACKIN_COPY: string = "servershutdownpremonition_backin_copy";
    public static SERVER_SHUTDOWNPREMONITION_COPY: string = "servershutdownpremonition_copy";
    public static SERVER_SHUTDOWNPREMONITION_REGISTERED_COPY: string = "servershutdownpremonition_registered_copy";
    public static SERVER_SHUTDOWN_COPY: string = "servershutdown_copy";
    public static SERVER_WELCOMEBACK_COPY: string = "welcomeback_copy";
    public static SERVER_WELCOMEBACK_TITLE: string = "welcomeback_title";

    //password
    public static PASSWORD_CHANGE_COPY_NEWPASS: string = "generic_change_password_copy_newpass";
    public static PASSWORD_CHANGE_COPY_OLDPASS: string = "generic_change_password_copy_oldpass";
    public static PASSWORD_CHANGE_COPY_SEND: string = "generic_change_password_copy_send";
    public static PASSWORD_CHANGE_FAILED: string = "generic_change_password_error_failed";
    public static PASSWORD_CHANGE_SUCCESS: string = "generic_change_password_error_success";
    public static PASSWORD_CHANGE_PWS_DONT_MATCH: string = "generic_change_password_faild_copy";
    public static PASSWORD_CHANGE_FAILED_SPECIALCHARACTERS: string = "generic_change_password_faild_specialcharacters";
    public static PASSWORD_CHANGE_FAILED_TITLE: string = "generic_change_password_faild_title";
    public static PASSWORD_CHANGE_TITLE: string = "generic_change_password_title";
    public static PASSWORD_GUEST_CHANGE_FAILED_COPY: string = "generic_guest_change_password_faild_copy";
    public static PASSWORD_GUEST_CHANGE_FAILED_TITLE: string = "generic_guest_change_password_faild_title";

    //payment
    public static PAYMENT_DISCOUNT_TITLE_GENERAL: string = "generic_discount_payment_title_general";
    public static PAYMENT_48HDISCOUNT_BUTTON: string = "generic_payment_48hdiscount_button";
    public static PAYMENT_48HDISCOUNT_BUTTON_GENERAL: string = "generic_payment_48hdiscount_button_general";
    public static PAYMENT_48HDISCOUNT_COPY: string = "generic_payment_48hdiscount_copy";
    public static PAYMENT_48HDISCOUNT_COPY_1: string = "generic_payment_48hdiscount_copy_1";
    public static PAYMENT_48HDISCOUNT_COPY_1_GENERAL: string = "generic_payment_48hdiscount_copy_1_general";
    public static PAYMENT_48HDISCOUNT_COPY_GENERAL: string = "generic_payment_48hdiscount_copy_general";
    public static PAYMENT_BTN: string = "generic_payment_btn";
    public static PAYMENT_COPY: string = "generic_payment_copy";
    public static PAYMENT_DISCOUNT_BUTTON: string = "generic_payment_discount_button";
    public static PAYMENT_DISCOUNT_COPY: string = "generic_payment_discount_copy";
    public static PAYMENT_DISCOUNT_COPY_GENERAL: string = "generic_payment_discount_copy_general";
    public static PAYMENT_DISCOUNT_GENERAL: string = "generic_payment_discount_general";
    public static PAYMENT_DISCOUNT_GENERALSHORT: string = "generic_payment_discount_generalshort";
    public static PAYMENT_DISCOUNT_TIME: string = "generic_payment_discount_time";
    public static PAYMENT_DISCOUNT_TITLE: string = "generic_payment_discount_title";
    public static PAYMENT_NEWPRICES: string = "generic_payment_newPrices";
    public static PAYMENT_TITLE: string = "generic_payment_title";
    public static PAYMENT_PRIMETIME_COPY_1: string = "primetime_copy1";
    public static PAYMENT_PRIMETIME_COPY_2: string = "primetime_copy2";
    public static PAYMENT_PRIMETIME_COPY_3: string = "primetime_copy3";
    public static PAYMENT_PRIMETIME_TITLE: string = "primetime_title";
    public static PAYMENT_PROMOTION_BONUS: string = "promotion_bonus";
    public static PAYMENT_PROMOTION_DISCOUNT_TIME: string = "promotion_discount_time";

    //progressbar
    public static LOADING_TEXT_01: string = "loading_text_1";
    public static LOADING_TEXT_02: string = "loading_text_2";
    public static LOADING_TEXT_03: string = "loading_text_3";
    public static LOADING_TEXT_04: string = "loading_text_4";
    public static LOADING_TEXT_05: string = "loading_text_5";
    public static LOADING_TEXT_06: string = "loading_text_6";
    public static LOADING_TEXT_07: string = "loading_text_7";
    public static LOADING_TEXT_08: string = "loading_text_8";
    public static LOADING_TEXT_09: string = "loading_text_9";
    public static LOADING_TEXT_10: string = "loading_text_10";
    public static LOADING_TEXT_11: string = "loading_text_11";
    public static LOADING_TEXT_12: string = "loading_text_12";
    public static LOADING_TEXT_13: string = "loading_text_13";
    public static LOADING_TEXT_14: string = "loading_text_14";
    public static LOADING_TEXT_15: string = "loading_text_15";
    public static LOADING_TEXT_16: string = "loading_text_16";
    public static LOADING_TEXT_17: string = "loading_text_17";
    public static LOADING_TEXT_18: string = "loading_text_18";
    public static LOADING_TEXT_19: string = "loading_text_19";
    public static LOADING_TEXT_20: string = "loading_text_20";
    public static LOADING_TEXT_DEFAULT: string = "loading_text_default";
    public static LOADING_TEXT_ITEMXML: string = "loading_text_itemXML";
    public static LOADING_PROGRESS_LOADFILES: string = "progress_loadfiles";
    public static LOADING_PROGRESS_SERVERCONNECTION: string = "progress_serverconnection";

    // register
    public static REGISTER_AGB_COPY: string = "generic_register_agb_copy";
    public static REGISTER_AGB_INFO_1: string = "generic_register_agb_info_1";
    public static REGISTER_AGB_INFO_2: string = "generic_register_agb_info_2";
    public static REGISTER_AGB_INFO_3: string = "generic_register_agb_info_3";
    public static REGISTER_AGB_READ: string = "generic_register_agb_read";
    public static REGISTER_ALREADYAVATAR: string = "generic_register_alreadyavatar";
    public static REGISTER_BADWORD: string = "generic_register_badword";
    public static REGISTER_BTN_AGB: string = "generic_register_btn_agb";
    public static REGISTER_BTN_LATER: string = "generic_register_btn_later";
    public static REGISTER_BTN_NEXT: string = "generic_register_btn_next";
    public static REGISTER_BTN_SAVE: string = "generic_register_btn_save";
    public static REGISTER_BUTTON_TEXT_1: string = "generic_register_button_text_1";
    public static REGISTER_BUTTON_TEXT_2: string = "generic_register_button_text_2";
    public static REGISTER_BUTTON_TEXT_3: string = "generic_register_button_text_3";
    public static REGISTER_BUTTON_TEXT_4: string = "generic_register_button_text_4";
    public static REGISTER_CHARACTER: string = "generic_register_character";
    public static REGISTER_COPY_0: string = "generic_register_copy_0";
    public static REGISTER_COPY_1: string = "generic_register_copy_1";
    public static REGISTER_EMAILLONG_COPY: string = "generic_register_emaillong_copy";
    public static REGISTER_EMAILWRONG_COPY: string = "generic_register_emailwrong_copy";
    public static REGISTER_EMAIL_COPY: string = "generic_register_email_copy";
    public static REGISTER_ERROR: string = "generic_register_error";
    public static REGISTER_ERRORMISTAKE: string = "generic_register_errormistake";
    public static REGISTER_ERROR_ACCOUNTALREADYEXISTS: string = "generic_register_error_accountalreadyexists";
    public static REGISTER_FORFREE: string = "generic_register_forfree";
    public static REGISTER_FORFREE_1: string = "generic_register_forfree1";
    public static REGISTER_INSERTEMAIL: string = "generic_register_insertEmail";
    public static REGISTER_INSERTNAME: string = "generic_register_insertName";
    public static REGISTER_INSERTPASSWORD: string = "generic_register_insertPassword";
    public static REGISTER_JOINFREENOW: string = "generic_register_joinFreeNow";
    public static REGISTER_LETSGO: string = "generic_register_letsgo";
    public static REGISTER_NAMEALREADYUSED: string = "generic_register_namealreadyused";
    public static REGISTER_NAMENOTVALID: string = "generic_register_namenotvalid";
    public static REGISTER_NAMETOOSHORT: string = "generic_register_nametooshort";
    public static REGISTER_OPTIONAL: string = "generic_register_optional";
    public static REGISTER_PASSWORDSHORT_COPY: string = "generic_register_passwordshort_copy";
    public static REGISTER_PASSWORD_INVALID: string = "error_password_invalid";
    public static REGISTER_PASSWORDWRONG_COPY: string = "generic_register_passwordwrong_copy";
    public static GENERIC_REGISTER_PASSWORDCHANGEWRONG_COPY: string = "generic_register_passwordchangewrong_copy";
    public static REGISTER_PASSWORD_COPY: string = "generic_register_password_copy";
    public static REGISTER_RECEIVENEWS: string = "generic_register_receivenews";
    public static REGISTER_REMEMBERDATA: string = "generic_register_rememberdata";
    public static REGISTER_REWARD: string = "generic_register_reward";
    public static REGISTER_SUBSCRIBE: string = "generic_register_subscribe";
    public static REGISTER_SUCCESS: string = "generic_register_success";
    public static REGISTER_TITLE: string = "generic_register_title";
    public static REGISTER_UNLOCK: string = "generic_register_unlock";

    //report
    public static REPORT_MUTED_BADWORD1_COPY: string = "generic_report_muted_badword1_copy";
    public static REPORT_MUTED_DOMAIN1: string = "generic_report_muted_domain1";
    public static REPORT_MUTED_REPORTED_COPY: string = "generic_report_muted_reported_copy";
    public static REPORT_PLAYER_COPY: string = "generic_report_player_copy";
    public static REPORT_PLAYER_REASON_0: string = "generic_report_player_reason_0";
    public static REPORT_PLAYER_REASON_1: string = "generic_report_player_reason_1";
    public static REPORT_PLAYER_REASON_2: string = "generic_report_player_reason_2";
    public static REPORT_PLAYER_REASON_3: string = "generic_report_player_reason_3";
    public static REPORT_PLAYER_REASON_TITLE: string = "generic_report_player_reason_title";
    public static REPORT_PLAYER_TITLE: string = "generic_report_player_title";
    public static REPORT_REPORTED_COPY: string = "generic_report_reported_copy";

    // worlds		
    public static WORLD_CONNECT: string = "generic_connect";
    public static WORLD_SELECT_WORLD: string = "generic_select_world";
    public static WORLD_TITLE: string = "generic_world";
    public static WORLD_TITLE_INTERNATIONAL: string = "generic_world_international";

    // value assignments
    public static VALUE_ASSIGN_COLON: string = "value_assign_colon";
    public static VALUE_WITH_BRACES: string = "value_with_braces";
    public static VALUE_PROPORTIONAL_VALUE: string = "value_proportional_value";
    public static VALUE_DASH_SPLIT: string = "value_dash_split";
    public static VALUE_PERCENTAGE_ADD: string = "value_percentage_add";
    public static VALUE_NOMINAL_ADD: string = "value_nominal_add";
    public static VALUE_NOMINAL_SUBTRACT: string = "value_nominal_subtract";
    public static VALUE_PREFIX_SUFFIX: string = "value_prefix_suffix";
    public static VALUE_MULTIPLIED: string = "value_multiplied";
    public static VALUE_COLON: string = "value_colon";
    public static VALUE_PERCENTAGE: string = "value_percentage";
    public static VALUE_XP: string = "value_xp";
    public static VALUE_COORDS: string = "value_coords";
    public static VALUE_PERCENTAGE_SUBTRACT: string = "value_percentage_subtract";
    public static VALUE_SIMPLE_COMP: string = "value_simple_comp";
    public static VALUE_CIRCA_NOMINAL: string = "value_circa_nominal";

    // labels
    public static LABEL_CHATMESSAGE_WITH_DATE: string = "label_chatmessage_with_date";
    public static LABEL_CHATMESSAGE_WITH_SHORT_DATE: string = "label_chatmessage_with_short_date";
}
